import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import {
  AddOrgEmpLeaves,
  getLeaveMasterType,
  leaveDashboardBalenceCount,
} from "./leaveService";
import { useFormik } from "formik";
import * as Yup from "yup";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { TostMsg } from "../../../App";
import LeaveManagerReport from "./CommonComponents/LeaveManagerReport";
import LeaveNavBarItems from "./CommonComponents/LeaveNavBarItems";
import { setLeaveRequestData } from "../../../Services/Redux/DataTransferToAnother";
import { useDispatch } from "react-redux";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

function ApplyLeave() {
  const [checkedHalfDay, setCheckedHalfDay] = useState(false);
  const [leaveType, setLeaveType] = useState([]);
  const [leaveCountType, setleaveCountType] = useState([]);
  const toster = useContext(TostMsg);
  const history = useHistory();
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let halfPreferences = "";
  const [Isloading, setIsloading] = useState(false);
  const [showHalfDay, setShowHalfDay] = useState(true);
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [dateError, setDateError] = useState(false);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [read, setRead] = useState(false);
  const [adjustment, setAdjustment] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const dispatch = useDispatch();
  const [selectedLeaveType, setSelectedLeaveType] = useState("");



  useEffect(() => {
    getLeaveType();
    getLeaveCount();
    permissionAccouncementList();

    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
    const dd = String(date.getDate()).padStart(2, "0");
    requestLeaveForm.setFieldValue("startDate", `${yyyy}-${mm}-${dd}`);
    requestLeaveForm.setFieldValue("endDate", `${yyyy}-${mm}-${dd}`);
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Leave.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Leave.Update") {
        setUpdate(true);
      } else if (UserPermission.PermissionName == "Leave.Delete") {
        setDeleted(true);
      } else if (UserPermission.PermissionName == "Leave.Read") {
        setRead(true);
      } else if (UserPermission.PermissionName == "Leave.Adjustment") {
        setAdjustment(true);
      }
    });
  };

  const requestLeaveValidation = Yup.object().shape({
    startDate: Yup.string().required("Start Date is required"),
    endDate: Yup.string().required("End Date is required"),
    leaveTypeId: Yup.string().required("Leave type is required"),
    reason: Yup.string().required("Reason is required"),
    isHalfDay: Yup.string(),
    halfPreference: Yup.string(),
  });

  const requestLeaveForm = useFormik({
    initialValues: {
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      leaveTypeId: "",
      reason: "",
      isHalfDay: "",
      halfPreference: "",
    },
    validationSchema: requestLeaveValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      if (!data?.startDate || !data?.endDate) return;
      const startDate = new Date(data?.startDate);
      const endDate = new Date(data?.endDate);
      const diffDays =
        (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);
      const leaveTypeBalance = leaveCountType.find(
        (item) => item.LeaveTypeId === Number(data?.leaveTypeId)
      );
      let halfPreferences = "";
      if (checkedHalfDay == false) {
        halfPreferences = "";
      } else {

        halfPreferences = data?.halfPreference ? "2" : "1";
      }
      setIsloading(true);
      const leaveRequestParams = {
        EmpId: userDetails?.EmpId,
        OrgId: userDetails?.OrgId,
        BranchId: userDetails?.BranchId,
        LoggedInEmpId: userDetails?.EmpId,
        LeaveTypeId: Number(data?.leaveTypeId),
        Reason: data?.reason,
        StartDate: startDate,
        EndDate: endDate,
        IsHalfDay: checkedHalfDay,
        HalfPreference: halfPreferences,
      };
      if (diffDays > leaveTypeBalance?.LeaveBalance) {
        toster.current.warn("Insufficient balance to apply for this leave.");
        setIsloading(false);
        return;
      }
      if (startDate > endDate) {
        setDateError(true);
        setIsloading(false);
        return;
      }
      try {
        const applyLeaveResponse = await AddOrgEmpLeaves(leaveRequestParams);
        if (applyLeaveResponse?.StatusCode === 2000) {
          GetMasterSystemAlertList("Leave_Added", 0);
          requestLeaveForm.resetForm();
          dispatch(setLeaveRequestData(leaveRequestParams));
          history.push("/Leave");
          setIsloading(false);
        } else {
          const message = applyLeaveResponse?.Message;
          toster.current.warn(message);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      } finally {
        setIsloading(false);
      }
    },
  });

  const scrolltoSubmit = useRef(null);
  const handleClick = () => {
    scrolltoSubmit?.current?.scrollIntoView({ behavior: "smooth" });
  };

  async function getLeaveType() {
    setIsloading(true);
    const params = {
      OrgId: userDetails?.OrgId,
    };
    try {
      const data = await getLeaveMasterType(params);
      let projectDetailData = await data;
      setLeaveType(projectDetailData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  async function getLeaveCount() {
    const param = {
      EmpId: userDetails?.EmpId,
      TypeId: 0,
    };
    try {
      const data = await leaveDashboardBalenceCount(param);
      let projectDetailData = await data;
      setleaveCountType(projectDetailData?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  useEffect(() => {
    const { startDate, endDate } = requestLeaveForm.values;
    if (
      Number(requestLeaveForm.values.leaveTypeId) === 105 ||
      Number(requestLeaveForm.values.leaveTypeId) === 108 ||
      Number(requestLeaveForm.values.leaveTypeId) === 106 ||
      Number(requestLeaveForm.values.leaveTypeId) === 107
    ) {
      setShowHalfDay(false);
    } else if (startDate && endDate) {
      setShowHalfDay(startDate === endDate);
    }

    if (masterSystemAlertData.length > 0) {
      toster.current.success(masterSystemAlertData);
    }
  }, [
    requestLeaveForm.values.startDate,
    requestLeaveForm.values.endDate,
    masterSystemAlertData,
    checkedHalfDay,
    requestLeaveForm.values.leaveTypeId,
  ]);

  const setEndDate = (event) => {
    const startDate = new Date(requestLeaveForm.values.startDate);
    const endDate = new Date(event);
    const normalizeDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);
    if (normalizedStartDate <= normalizedEndDate) {
      setDateError(false);
      setCheckedHalfDay(false);
      halfPreferences = "";
    } else {
      setDateError(true);
      setCheckedHalfDay(true);
    }
  };

  const setStartDate = (event) => {
    const selectedStartDate = new Date(event);
    const currentEndDate = new Date(requestLeaveForm.values.endDate);
    if (selectedStartDate >= currentEndDate) {
      requestLeaveForm.setFieldValue("endDate", event);
      setDateError(false);
      setCheckedHalfDay(false);
      halfPreferences = "";
    }
  };



  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid position-relation">
        <div className="row g-3 ">
          <div className="form-head mb-3">
            <div className="row ">
              <div className="col-lg-5">
                <div className="">
                  <h2 className="font-w600 mb-0">Leave Dashboard</h2>
                  <p className="text-light">
                    Monitor requests, track balances, and ensure smooth
                    workforce planning — all in one place
                  </p>
                </div>
              </div>
              <div className="col-lg-7">
                <LeaveNavBarItems />
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <div className="row card-radius">
              <div className="col-xl-12">
                <div className="balance-section">
                  <div className="balance-header">
                    <div class="balance-title-wrap">
                      <div class="balance-icon-wrap">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path></svg>
                      </div>
                      <div>
                        <div class="balance-heading">Leave Balance</div>
                        <div class="balance-sub">Take a breather — check your leave balance</div>
                      </div>
                    </div>

                    {create && (
                      <button class="apply-btn" onClick={handleClick}>
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4"></path></svg>

                        Apply Leave

                      </button>
                    )}

                  </div>
                  <div className="balance-body">
                    <div className="leave-image">
                      <svg viewBox="0 0 120 130" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <ellipse cx="60" cy="115" rx="30" ry="8" fill="#e8e2f5" opacity=".5"></ellipse>

                        <rect x="52" y="90" width="10" height="22" rx="5" fill="#26a69a"></rect>
                        <rect x="58" y="90" width="10" height="22" rx="5" fill="#1a7a74"></rect>

                        <rect x="40" y="55" width="40" height="40" rx="14" fill="#671cc9"></rect>

                        <path d="M55 55 L60 65 L65 55" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity=".5"></path>

                        <path d="M40 68 Q20 60 10 58" stroke="#f7c5a8" stroke-width="8" stroke-linecap="round"></path>

                        <circle cx="10" cy="58" r="5" fill="#f7c5a8"></circle>

                        <path d="M80 65 Q96 50 102 38" stroke="#f7c5a8" stroke-width="8" stroke-linecap="round"></path>
                        <circle cx="102" cy="38" r="5" fill="#f7c5a8"></circle>

                        <circle cx="60" cy="36" r="20" fill="#f7c5a8"></circle>

                        <path d="M40 30 Q44 14 60 12 Q76 14 80 30 Q72 22 60 22 Q48 22 40 30Z" fill="#2d1a0e"></path>

                        <circle cx="53" cy="36" r="3" fill="#2d1a0e"></circle>
                        <circle cx="67" cy="36" r="3" fill="#2d1a0e"></circle>
                        <circle cx="54" cy="35" r="1" fill="#fff"></circle>
                        <circle cx="68" cy="35" r="1" fill="#fff"></circle>

                        <path d="M54 43 Q60 48 66 43" stroke="#2d1a0e" stroke-width="1.5" stroke-linecap="round" fill="none"></path>

                        <g transform="translate(94,18) rotate(-30)">
                          <path d="M0 0 L22 8 L0 16 L4 8 Z" fill="#ec4119"></path>
                          <path d="M0 16 L4 8 L22 8" stroke="#fff" stroke-width=".8" fill="none" opacity=".5"></path>
                        </g>

                        <path d="M98 38 Q88 32 78 28" stroke="#ec4119" stroke-width="1.5" stroke-dasharray="3 3" opacity=".5" stroke-linecap="round"></path>
                      </svg>
                      {/* <div className="current-user">
                            <div className="">
                              <img
                                className="avatar is-squared w-100"
                                src="images/org-img/leave/leaves.png"
                                data-demo-src="images/avatar/5.jpg"
                                alt=""
                              />
                            </div>
                          </div> */}
                    </div>
                    <div className="leave-types-grid center">
                      {leaveCountType
                        ?.slice(2, leaveCountType.length)
                        ?.map((countData, index) => {
                          return (
                            <a
                              className="leave-type-card"
                              key={index}
                              style={{ cursor: "unset" }}
                            >
                              <div className="leave-summaryicons">
                                <div className="lt-icon">
                                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                                </div>
                               
                                {/* <img src="/images/menu-icon/leave.svg" /> */}
                              </div>
                              <div className="lt-num">
                                {countData?.LeaveBalance?.toFixed(1)}
                              </div>

                              <div className="lt-name">
                                {countData?.LeaveType}
                              </div>
                             

                            </a>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="notice-div d-flex">
              <div className="first-coll">
                <img src="images/org-img/leave/1.png" className="w-100" />
              </div>
              <div className="second-coll"></div>
            </div>
            {create && (
              <div className="col-xl-12">
                <div className="request-section">
                    <div className="request-header">
                      <div class="req-icon-wrap">
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                      </div>
                      <div>
                        <div class="request-title">Request a Leave</div>
                        <div class="request-sub">Fill in the details below and submit for manager approval</div>
                      </div>
                    </div>
                    <div className="request-body">
                      <div className="applyleaveform">
                        <form onSubmit={requestLeaveForm.handleSubmit}>
                          <div className="row align-items-center">
                            <div className="col-xl-12">
                              <div className="row">
                                <div className="mb-4 col-md-12">
                                  <label className="form-label">
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>Why you want this Leave ?
                                  </label>
                                  {/* cover-form position-relative */}
                                  <div className="">
                                    <textarea
                                      rows="5"
                                      cols="1"
                                      name="reason"
                                      className={
                                        "form-control h-auto" +
                                        (requestLeaveForm.errors.reason &&
                                          requestLeaveForm.touched.reason
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={requestLeaveForm.handleChange}
                                      value={requestLeaveForm.values.reason}
                                      maxLength={500}
                                      placeholder="Please enter any details that management should take into consideration"
                                    ></textarea>
                                    <div
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        position: "absolute",
                                        right: "27px",
                                        bottom: "1px",
                                        color:
                                          requestLeaveForm.values.reason
                                            .length === 500
                                            ? "red"
                                            : "#555",
                                      }}
                                    >
                                      {requestLeaveForm.values.reason.length}/
                                      {500}
                                    </div>
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestLeaveForm.errors.reason &&
                                      requestLeaveForm.touched.reason
                                      ? requestLeaveForm.errors.reason
                                      : null}
                                  </div>
                                </div>

                                <div className="mb-4 col-md-6">
                                  <label className="form-label"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>Start Date</label>
                                  <div className="">
                                    <input
                                      type="date"
                                      name="startDate"
                                      onClick={(e) =>
                                        e.target.showPicker &&
                                        e.target.showPicker()
                                      }
                                      min={
                                        selectedLeaveType == 105 ||
                                          selectedLeaveType == 106
                                          ? undefined
                                          : new Date(
                                            Date.now() - 7 * 24 * 60 * 60 * 1000
                                          )
                                            .toISOString()
                                            .split("T")[0]
                                      }
                                      className={
                                        "form-control" +
                                        (requestLeaveForm.errors.startDate &&
                                          requestLeaveForm.touched.startDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={(event) => {
                                        setStartDate(event.target.value);
                                        requestLeaveForm.handleChange(event);
                                      }}
                                      value={
                                        requestLeaveForm.values.startDate ||
                                        new Date().toISOString().split("T")[0]
                                      }
                                      placeholder="Start Date"
                                    />
                                  </div>
                                  <div className="invalid-feedback">
                                    {requestLeaveForm.errors.startDate &&
                                      requestLeaveForm.touched.startDate
                                      ? requestLeaveForm.errors.startDate
                                      : null}
                                  </div>
                                </div>

                                <div className="mb-4 col-md-6">
                                  <label className="form-label"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>End Date</label>
                                  <div className="">
                                    <input
                                      type="date"
                                      name="endDate"
                                      onClick={(e) =>
                                        e.target.showPicker &&
                                        e.target.showPicker()
                                      }
                                      className={
                                        "form-control" +
                                        (requestLeaveForm.errors.endDate &&
                                          requestLeaveForm.touched.endDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      onChange={(event) => {
                                        setEndDate(event.target.value);
                                        requestLeaveForm.handleChange(event);
                                      }}
                                      value={
                                        requestLeaveForm.values.endDate ||
                                        new Date().toISOString().split("T")[0]
                                      }
                                      placeholder="End Date"
                                    />
                                  </div>

                                  <div className="invalid-feedback">
                                    {requestLeaveForm.errors.endDate &&
                                      requestLeaveForm.touched.endDate
                                      ? requestLeaveForm.errors.endDate
                                      : null}
                                  </div>
                                  {dateError ? (
                                    <span className="invalid-feedback">
                                      {" "}
                                      * End date should be greater than or equal
                                      to start date.
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-6">
                              <div className="mb-4 col-md-12">
                                <label className="form-label"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path></svg>Leave Type</label>
                                <div className="">
                                  <select
                                    id="inputState"
                                    name="leaveTypeId"
                                    className={
                                      " form-control wide" +
                                      (requestLeaveForm.errors.leaveTypeId &&
                                        requestLeaveForm.touched.leaveTypeId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    onChange={(e) => {
                                      setSelectedLeaveType(e.target.value);
                                      requestLeaveForm.handleChange(e);
                                    }}
                                    value={requestLeaveForm.values.leaveTypeId}
                                  >
                                    <option selected="">Choose...</option>
                                    {leaveType?.map((option) => (
                                      <option key={option?.Id} value={option?.LeaveTypeId}>
                                        {option?.LeaveTypes}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="invalid-feedback">
                                  {requestLeaveForm.errors.leaveTypeId &&
                                    requestLeaveForm.touched.leaveTypeId
                                    ? requestLeaveForm.errors.leaveTypeId
                                    : null}
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-6">
                              {showHalfDay && (
                                <div className="half-day-wrap">
                                  <div className="form-check custom-checkbox checkbox-success">
                                    <input
                                      type="checkbox"
                                      id="customCheckBox3"
                                      name="isHalfDay"
                                      className={
                                        "form-check-input half-day-checkbox" +
                                        (requestLeaveForm.errors.isHalfDay &&
                                          requestLeaveForm.touched.isHalfDay
                                          ? " is-invalid"
                                          : "")
                                      }
                                      checked={checkedHalfDay}
                                      onChange={(e) =>
                                        setCheckedHalfDay(e.target.checked)
                                      }
                                      value={requestLeaveForm.values.isHalfDay}
                                      style={{ borderColor: "#a49a9a" }}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="customCheckBox3"
                                    >
                                      Half Day ?
                                    </label>
                                  </div>
                                  {checkedHalfDay && (
                                    <div className="basic-form mx-3">
                                      <label className="switch2">
                                        <input
                                          type="checkbox"
                                          disabled={
                                            checkedHalfDay == false ? true : false
                                          }
                                          name="halfPreference"
                                          onChange={requestLeaveForm.handleChange}
                                          value={
                                            requestLeaveForm.values.halfPreference
                                          }
                                        />
                                        <span>
                                          <em></em>
                                          <strong></strong>
                                        </span>
                                      </label>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                            <div className="col-xl-12">
                              <button
                                ref={scrolltoSubmit}
                                type="submit"
                                className="savebtn-click m-0"
                                style={{ width: "auto", minWidth: "fit-content" }}
                              >
                                Submit Request
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-xl-4">
            <LeaveManagerReport />
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default ApplyLeave;
